/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取电子票明文码
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetETicketCodeParams {
  constructor(public eticketQrCode: string) {}
}

export default async function (
  params: GetETicketCodeParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/ticket-folder/eticket-code`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
